import { createInstance } from "@jonkoops/matomo-tracker-react";

const URL_BASE = "https://stepfinance.matomo.cloud/";

export const MATOMO_INSTANCE = createInstance({
  urlBase: URL_BASE,
  siteId: 1,
  disabled: false, // optional, false by default. Makes all tracking calls no-ops if set to true.
  heartBeat: {
    // optional, enabled by default
    active: true, // optional, default value: true
    seconds: 10, // optional, default value: `15
  },
  linkTracking: false, // optional, default value: true
  configurations: {
    setSecureCookie: true,
    setRequestMethod: "POST",
    setCookieDomain: "*.step.finance",
  },
});
